import {
  responsiveMargin,
  responsiveMarginB,
  responsiveMarginT,
  responsiveMarginX,
  responsiveMarginY,
  responsivePaddings,
  responsivePaddingX,
  responsivePaddingY,
} from "@/ui/utils/spacings"
import { classNames, ResponsiveStringValue } from "@punks/ui-core"

export interface BoxProps {
  children: any
  className?: string
  styles?: React.CSSProperties
  p?: ResponsiveStringValue
  px?: ResponsiveStringValue
  py?: ResponsiveStringValue
  m?: ResponsiveStringValue
  mx?: ResponsiveStringValue
  my?: ResponsiveStringValue
  mt?: ResponsiveStringValue
  mb?: ResponsiveStringValue
}

const Box = ({
  children,
  className,
  styles,
  p,
  px,
  py,
  m,
  mx,
  my,
  mt,
  mb,
}: BoxProps) => {
  const pValue = p ? responsivePaddings(p) : undefined
  const pxValue = px ? responsivePaddingX(px) : undefined
  const pyValue = py ? responsivePaddingY(py) : undefined
  const mValue = m ? responsiveMargin(m) : undefined
  const mxValue = mx ? responsiveMarginX(mx) : undefined
  const myValue = my ? responsiveMarginY(my) : undefined
  const mtValue = mt ? responsiveMarginT(mt) : undefined
  const mbValue = mb ? responsiveMarginB(mb) : undefined
  return (
    <div
      style={{
        ...pValue?.styles,
        ...pxValue?.styles,
        ...pyValue?.styles,
        ...mValue?.styles,
        ...mxValue?.styles,
        ...myValue?.styles,
        ...mtValue?.styles,
        ...mbValue?.styles,
        ...styles,
      }}
      className={classNames(
        pValue?.classes,
        pxValue?.classes,
        pyValue?.classes,
        mValue?.classes,
        mxValue?.classes,
        myValue?.classes,
        mtValue?.classes,
        mbValue?.classes,
        className
      )}
    >
      {children}
    </div>
  )
}

export default Box
